import { useMedia } from "react-use";

/**
 * Breakpoints matching tailwind.config.js screens.
 * Hardcoded to avoid runtime dependency on tailwindcss/resolveConfig
 * (removed in Tailwind v4).
 */
export const xs = "375px";
export const sm = "416px";
export const md = "624px";
export const lg = "1056px";
export const xl = "1440px";

export function useMediaMinWidth(minWidth: string, defaultState?: boolean) {
  return useMedia(`(min-width: ${minWidth})`, defaultState);
}
